require('./myProfileTppRemoveConsentSuccessView.scss');

//@vendors
const React = require('react');
const PropTypes = require('prop-types');
//@ commons
const { FormattedText } = require('core/i18n').i18n;
const { OKLink } = require('commonsComponents/OKLink');

class MyProfileTppRemoveConsentSuccess extends React.Component {

    componentWillUnmount = () => {
        const {resetTppKey} = this.props;
        resetTppKey();
    }

    render() {
        return (
            <div className="consent-remove-success">
                <div className="consent-remove-success__header">
                    <div className="consent-remove-success__icon-success"></div>
                    <h3 className="consent-remove-success__title">
                        <FormattedText value="keysTppView-removeTPPKeySuccessTitle"/>
                    </h3>
                    <span className="consent-remove-success__separator"></span>
                    <h4 className="consent-remove-success__sub-title">
                        <FormattedText value="cosentRemoveSuccess-removeConsentTppSuccessTitle"/>
                    </h4>
                </div>

                <div className="consent-remove-success__divider" />
                
                <div className="row">
                    <div className="consent-remove-success__footer">
                        <OKLink
                            to="/myprofile/keys/tpps"
                            modifier="editorial"
                        >
                            <FormattedText value="keysTppView-goBack"/>
                        </OKLink>
                    </div>
                </div>
            </div>
        )
    }
}

MyProfileTppRemoveConsentSuccess.propTypes = {
    resetTppKey: PropTypes.func.isRequired
};

module.exports = MyProfileTppRemoveConsentSuccess;